export default "__VITE_ASSET__CMg7GSGQ__"